module.exports = __webpack_public_path__ + "img/Cutaways_house_1_a.2ce78bd6.jpg";